import {
  getEndPoint,
  getNodeEntries,
  GetNodeEntriesOptions,
  getNodeString,
  insertNodes,
  isText,
  select,
  TText,
} from '@udecode/plate';
import twitterText from 'twitter-text';

import { BufferEditor } from '~/editor/BufferEditor/types.plate';
import { TwitterMentionInputElement } from '../nodes';

/**
 * Find all text in the editor that are valid twitter
 * mentions and convert them to twitter mention elements
 */
export const findAndCreateTwitterMentions = (
  editor: BufferEditor,
  options?: Pick<GetNodeEntriesOptions, 'at' | 'reverse'>
): void => {
  // Get all leaf text nodes
  const leafEntriesGenerator = getNodeEntries<TText>(editor, {
    at: [],
    ...options,
    reverse: true,
    mode: 'all',
    match: (n) => isText(n),
  });
  const leafEntries = Array.from(leafEntriesGenerator);

  // Iterate over the leaf text nodes
  leafEntries.forEach(([node, nodePath]) => {
    const nodeText = getNodeString(node);

    // Search for mentions and wrap them with twitter mentions elements
    twitterText
      .extractMentionsWithIndices(nodeText)
      .reverse()
      .forEach((mention) => {
        const range = {
          anchor: { path: nodePath, offset: mention.indices[0] },
          focus: { path: nodePath, offset: mention.indices[1] },
        };
        insertNodes(
          editor,
          TwitterMentionInputElement.new(mention.screenName),
          {
            at: range,
          }
        );
      });
  });

  // Move selection to end of editor content
  const editorEndPoint = getEndPoint(editor, []);
  select(editor, {
    anchor: editorEndPoint,
    focus: editorEndPoint,
  });
};
